import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/", { replace: true });
      return;
    }
    const session_id = m[1];
    (async () => {
      try {
        await api.post("/auth/session", { session_id });
        // strip the fragment
        window.history.replaceState({}, "", "/dashboard");
        navigate("/dashboard", { replace: true });
      } catch (e) {
        navigate("/", { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#05070A] text-[#F8FAFC]">
      <div className="text-center">
        <Loader2 size={36} className="mx-auto animate-spin text-[#D4AF37]" />
        <p className="mt-4 font-serif-mystic text-2xl">Aligning the stars…</p>
      </div>
    </div>
  );
}
